<script setup>
// NOTICE: KAPTION-INTEGRATION
// two-step-verification.API.1 — asks for the current password before a
// method is removed or the backup codes are replaced. The caller does the
// request in `onConfirm(password)` and resolves with an error message or null.
import { ref } from 'vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Input from 'dashboard/components-next/input/Input.vue';

const dialogRef = ref(null);
const title = ref('');
const description = ref('');
const confirmLabel = ref('');
const destructive = ref(true);
const password = ref('');
const busy = ref(false);
const error = ref('');
let handler = null;

const open = options => {
  title.value = options.title;
  description.value = options.description;
  confirmLabel.value = options.confirmLabel;
  destructive.value = options.destructive !== false;
  handler = options.onConfirm;
  password.value = '';
  error.value = '';
  busy.value = false;
  dialogRef.value?.open();
};

const close = () => dialogRef.value?.close();

const confirm = async () => {
  if (busy.value || !password.value || !handler) return;
  busy.value = true;
  error.value = '';
  const message = await handler(password.value);
  busy.value = false;
  if (message) {
    error.value = message;
  } else {
    close();
  }
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :type="destructive ? 'alert' : 'edit'"
    :title="title"
    :description="description"
    :confirm-button-label="confirmLabel"
    :is-loading="busy"
    :disable-confirm-button="!password"
    @confirm="confirm"
  >
    <div class="flex flex-col gap-2">
      <Input
        v-model="password"
        type="password"
        autocomplete="current-password"
        :label="$t('KAPTION_TWO_STEP.REMOVE_DIALOG.PASSWORD_LABEL')"
        data-testid="kpt-two-step-password"
      />
      <p v-if="error" class="text-sm text-n-ruby-11" role="alert">
        {{ error }}
      </p>
    </div>
  </Dialog>
</template>
